import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRectangleHistoryCirclePlus } from '@fortawesome/pro-solid-svg-icons';

import AddToList from './add_to_list';
import { Button } from 'react-bootstrap-5';

export default function AddToListButton({
  insightsPropertyId
}) {
  return (
    <AddToList items={[{ callListableType: 'Insights::Property', callListableId: insightsPropertyId }]}>
      <Button variant="outline-primary">
        <FontAwesomeIcon className="me-2" icon={faRectangleHistoryCirclePlus}/>
        Add To List
      </Button>
    </AddToList>
  );
}

AddToListButton.propTypes = {
  insightsPropertyId: PropTypes.number
};
